import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Locale from './vue-i18n-locales.generated';


Vue.use(VueI18n)

export default new VueI18n({
    locale: 'en',
    messages: Locale,
    silentTranslationWarn: true
})